import { DialogAddToPOSItems } from './DialogAddToPOSItems';
import { DialogNewMenuItem } from './DialogNewMenuItem';

export default {
    NewMenuItem: DialogNewMenuItem,
    AddToPOSItems: DialogAddToPOSItems,
};
